<template>
  <div v-loading="loading">

    <transition name="fade" mode="out-in">
      <div v-if="active == 1" key="stepone" style="min-height:500px" class="mb-2">
        <business-information :business_types="business_types" :initial_business="business" :warehouses="warehouses"
          @next="onNext" :agencies="agencies"></business-information>
      </div>

      <div v-else-if="active == 2" class="" key="steptwo" style="min-height:500px">
        <business-property-information :initial_business="business" @next="onNext" @previous="onPrevious"
          :regions="regions" :pic-certifications="picCertifications" :pic-categories="picCategories" @submit="onSubmit"
          @draft="onSubmitDraft"></business-property-information>
      </div>

      <!-- <div v-else-if="active == 3" class="" key="stepthree" style="min-height:500px">
        <business-documentation
          :initial_business="business"
          @submit="onSubmit"
          @draft="onSubmitDraft"
          @previous="onPrevious"
        ></business-documentation>
      </div> -->

    </transition>
  </div>
</template>



<script>
import Business from "../../models/Business";
import BusinessStatuses from "../../../constants/BusinessStatuses";

export default {
  props: {
    business_types: {
      type: Array
    },
    warehouses: {
      type: Array
    },
    agencies: {
      type: Array
    },
    regions: {
      type: Array
    },
    picCertifications: {
      type: Array
    },
    picCategories: {
      type: Array
    },
    redirect_location: {
      type: String,
      default: '/admin/businesses'
    },
    agencyId: {
      type: [Number, String],
    }
  },
  data() {
    return {
      //
      business: new Business({
        address: '',
        business_type_id: "",
        business_status_id: BusinessStatuses.pending_approval.id,
        extra_attributes: { address: {} },
        users: [], // This is causing an issue with customers form being disabled
        properties: [{
          extra_attributes: { address: {} },
          lng: '',
          lat: '',
        }],
        guarantors: [],
        media: {
          privacy_documents: [],
          finance_requirement_documents: []
        },
        agency_id: this.agencyId || null,
        warehouse_id: null,
      }),
      loading: false,
      active: 1
    };
  },
  methods: {
    onNext(business) {
      this.business = business;
      if (this.active++ > 3) {
        this.active = 1;
      }
    },
    onPrevious(business) {
      this.business = business;
      if (this.active-- <= 1) this.active = 1;
    },
    onSubmit(business) {
      this.loading = true;
      this.business = business;
      this.business.cs_eligible = this.business.warehouse_id == 1;
      this.business.finance_capacity = this.business.dollar_finance_capacity * 100;
      this.business
        .save()
        .then(result => {
          //Save any potential documents

          this.$message({
            type: "success",
            message: "Producer Saved"
          });

          window.location.href = this.redirect_location + '/' + result.id;
        })
        .catch(errors => {
          console.log(errors);
          var errorText = "";
          _.forEach(errors.response.data.errors, function (value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText
          });
          this.loading = false;
        });
    },
    onSubmitDraft(business) {
      business.business_status_id = BusinessStatuses.draft.id;
      this.onSubmit(business);
    },
    makeUser() {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 12; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return {
        roles: ["user"],
        active: true,
        password: result,
        password_confirmation: result
      };
    }
  }
};
</script>